import React, { useEffect, useState, useRef } from "react";
import Footer from "../../Components/Footer";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import PagesHeader from "../../Components/PagesHeader";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { ApiService } from "../../Components/Services/apiservices";

let apiServices = new ApiService();

function Weddings() {
  const didMountRef = useRef(true);
  const { slug } = useParams();
  const [pageData, setPageData] = useState({}); // get page id from url
  const [pageSlug, setPageSlug] = useState("");
  const [faqData, setfaqData] = useState([]);
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [guests, setGuests] = useState("");
  const [contactTime, setContactTime] = useState("");
  const [message, setMessage] = useState("");
  const [agree, setAgree] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessmessage] = useState("");
  const [loading, setLoading] = useState(false);
  const getfaqData = (page_id) => {
    apiServices
      .getFaqDataRequest(page_id)
      .then((res) => {
        if (res.data.status === "success") {
          setfaqData(res.data.faqdata);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (didMountRef.current) {
      const dataString = {
        page_url: "wedding-venue-in-london",
      };
      apiServices.pagePostRequest(dataString).then((res) => {
        if (res.data.status === "success") {
          if (res.data.pageData != null) {
            setPageData(res.data.pageData);
            getfaqData(res.data.pageData?.page_id);
          }
        }
      });
    }

    didMountRef.current = false;
  }, []);

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   // ✅ Validation
  //   if (!fullName || !phone || !email || !eventDate || !contactTime) {
  //     setErrorMessage("Please fill all required fields.");
  //     return;
  //   }

  //   if (!agree) {
  //     setErrorMessage("Please agree to be contacted.");
  //     return;
  //   }

  //   setErrorMessage("");

  //   const dataString = {
  //     fullName: fullName,
  //     phone: phone,
  //     email: email,
  //     eventDate: eventDate,
  //     guests: guests,
  //     contactTime: contactTime,
  //     message: message,
  //   };

  //   apiServices.weddingenqprocessPostRequest(dataString).then((res) => {
  //     if (res.data.status === "success") {
  //       setSuccessmessage(res.data.message);

  //       // ✅ reset form
  //       setFullName("");
  //       setPhone("");
  //       setEmail("");
  //       setEventDate("");
  //       setGuests("");
  //       setContactTime("");
  //       setMessage("");
  //       setAgree(false);

  //       // redirect
  //       setTimeout(() => {
  //         window.location.href = "/thank-you";
  //       }, 2000);
  //     } else {
  //       setErrorMessage(res.data.message);
  //     }
  //   });
  // };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!fullName || !phone || !email || !eventDate || !contactTime) {
      setErrorMessage("Please fill all required fields.");
      return;
    }

    if (!agree) {
      setErrorMessage("Please agree to be contacted.");
      return;
    }

    setErrorMessage("");
    setLoading(true); // ✅ start loading

    const dataString = {
      fullName,
      phone,
      email,
      eventDate,
      guests,
      contactTime,
      message,
    };

    apiServices
      .weddingenqprocessPostRequest(dataString)
      .then((res) => {
        if (res.data.status === "success") {
          setSuccessmessage(res.data.message);

          setFullName("");
          setPhone("");
          setEmail("");
          setEventDate("");
          setGuests("");
          setContactTime("");
          setMessage("");
          setAgree(false);

          setTimeout(() => {
            window.location.href = "/thank-you";
          }, 2000);
        } else {
          setErrorMessage(res.data.message);
        }
      })
      .catch(() => {
        setErrorMessage("Something went wrong!");
      })
      .finally(() => {
        setLoading(false); // ✅ stop loading
      });
  };

  return (
    <>
      <PagesHeader />

      <section className="hero-slider">
        <Swiper
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{ delay: 4000 }}
          loop={true}
        >
          <SwiperSlide>
            <div
              className="hero-slide"
              style={{
                backgroundImage:
                  "url(https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773746425.png)",
              }}
            >
              <div className="hero-content">
                <h1>Celebrate Your Dream Wedding</h1>
                <p>Luxury Indian Wedding Venue in London</p>
                <a
                      href="#"
                      className="discovers-btn new"
                      onClick={(e) => {
                        e.preventDefault();
                        const element = document.getElementById("weddingForm");
                        const offset = 80; // adjust header height
                        const position = element.offsetTop - offset;

                        window.scrollTo({
                          top: position,
                          behavior: "smooth",
                        });
                      }}
                    >
                      <span>ENQUIRE NOW</span>
                    </a>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div
              className="hero-slide"
              style={{
                backgroundImage:
                  "url(https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773746470.png)",
              }}
            >
              <div className="hero-content">
                <h1>Elegant Wedding Celebrations</h1>
                <p>Create unforgettable memories</p>
                 <a
                      href="#"
                      className="discovers-btn new"
                      onClick={(e) => {
                        e.preventDefault();
                        const element = document.getElementById("weddingForm");
                        const offset = 80; // adjust header height
                        const position = element.offsetTop - offset;

                        window.scrollTo({
                          top: position,
                          behavior: "smooth",
                        });
                      }}
                    >
                      <span>ENQUIRE NOW</span>
                    </a>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div
              className="hero-slide"
              style={{
                backgroundImage:
                  "url(https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773746586.png)",
              }}
            >
              <div className="hero-content">
                <h1>Perfect Venue for Your Big Day</h1>
                <p>Experience luxury and tradition together</p>
                 <a
                      href="#"
                      className="discovers-btn new"
                      onClick={(e) => {
                        e.preventDefault();
                        const element = document.getElementById("weddingForm");
                        const offset = 80; // adjust header height
                        const position = element.offsetTop - offset;

                        window.scrollTo({
                          top: position,
                          behavior: "smooth",
                        });
                      }}
                    >
                      <span>ENQUIRE NOW</span>
                    </a>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              className="hero-slide"
              style={{
                backgroundImage:
                  "url(https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773746643.png)",
              }}
            >
              <div className="hero-content">
                <h1>Perfect Venue for Your Big Day</h1>
                <p>Experience luxury and tradition together</p>
                 <a
                      href="#"
                      className="discovers-btn new"
                      onClick={(e) => {
                        e.preventDefault();
                        const element = document.getElementById("weddingForm");
                        const offset = 80; // adjust header height
                        const position = element.offsetTop - offset;

                        window.scrollTo({
                          top: position,
                          behavior: "smooth",
                        });
                      }}
                    >
                      <span>ENQUIRE NOW</span>
                    </a>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>

      <section className="services section-padding">
        <div className="container">
          <h2 className="text-center mb-4 section-title">
            Discover the Perfect Wedding Venue in London
          </h2>
          <p className="text-center mb-5">
            Watch how the most romantic love story unfolds in London at a place
            that truly feels yours. At Chokhi Dhani London, we bring together
            rich Indian heritage, warm hospitality, and delectable Rajasthani
            cuisines that turn your wedding into something far beyond a
            memorable celebration.
          </p>
        </div>
      </section>

      <section className="services">
        <div className="container" style={{ marginBottom: "80px" }}>
          {/* <h2 className="text-center mb-4 section-title">
            Discover the Perfect Wedding Venue in London
          </h2> */}
          <div className="row">
            <div
              className="col-md-6 bg-blck p-0 order2 valign "
              data-animate-effect="fadeInLeft"
            >
              <div className="content">
                <div className="cont text-left">
                  <h2 className="section-title">
                    Why Choose Chokhi Dhani as Your Wedding Venue in London?
                  </h2>
                  <p>
                    Bringing the soul of Indian culture into the heart of
                    London, Chokhi Dhani is not just a backdrop for your big
                    day. It is a place where your families and guests will feel
                    welcomed, and the whole event will carry a warmth of true
                    joy and love. From luxurious venues to unforgettable
                    culinary experiences, we turn your dream wedding into a
                    reality. If you are looking for the{" "}
                    <strong>best wedding venue in London</strong> that blends
                    cultural authenticity with genuine hospitality, you have
                    found it.
                  </p>
                  <div className="butn-dark">
                    {" "}
                     <a
                      href="#"
                      className="discover-btn new"
                      onClick={(e) => {
                        e.preventDefault();
                        const element = document.getElementById("weddingForm");
                        const offset = 80; // adjust header height
                        const position = element.offsetTop - offset;

                        window.scrollTo({
                          top: position,
                          behavior: "smooth",
                        });
                      }}
                    >
                      <span>ENQUIRE NOW NOW</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 p-0 order1 "
              data-animate-effect="fadeInRight"
            >
              <div className="img">
                <img
                  src="https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773733021.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="rooms1 section-padding bg-blck-light"
        data-scroll-index="2"
      >
        <div className="container">
          <h2 className="text-center mb-4 section-title">
            A Perfect Setting for Your Special Day
          </h2>

          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={3}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000 }}
            breakpoints={{
              320: { slidesPerView: 1 },
              576: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 3 },
            }}
          >
            <SwiperSlide>
              <div className="venue-card">
                <img
                  src="https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773748225.jpg"
                  alt="Codrington Room"
                  className="venue-img"
                />

                <div className="venue-overlay">
                  <h3>Corporate Events</h3>

                  <p>
                    Corporate events need a professional yet mesmerising setup.
                    These spaces manage to keep things professional and visually
                    appealing. You can host a proper meeting, a dinner, or even
                    a networking evening, and it all feels a bit more relaxed,
                    which people usually appreciate more than they say.
                  </p>

                  {/* <a href="/codrington-room" className="venue-btn">
                    LEARN MORE
                  </a> */}
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="venue-card">
                <img
                  src="https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773748613.jpg"
                  alt="Rooftop Restaurant"
                  className="venue-img"
                />

                <div className="venue-overlay">
                  <h3>Rooftop Restaurant</h3>

                  <p>
                    Open skies, the River Thames catching the last light of the
                    evening, and London's skyline spread out in every direction.
                    Our rooftop restaurant brings all of that to your wedding
                    day, turning a reception into something your guests will be
                    talking about long after the night ends. For couples looking
                    for a truly unique wedding venue in London, this is the one
                    you must book immediately.
                  </p>

                  {/* <a href="/codrington-room" className="venue-btn">
                    LEARN MORE
                  </a> */}
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="venue-card">
                <img
                  src="https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773748361.jpg"
                  alt="Codrington Room"
                  className="venue-img"
                />

                <div className="venue-overlay">
                  <h3>Private Dining Room</h3>

                  <p>
                    Luxurious, intimate, and elegant, the Private Dining Room at
                    Chokhi Dhani is perfect for making small gatherings feel
                    special. With intricate carvings, artwork, and chandeliers,
                    it reflects a rich Indian charm and seats up to 14 guests.
                    Ideal for an intimate wedding reception in London, it can
                    host up to 30 guests for cocktails and canapés.
                  </p>

                  {/* <a href="/codrington-room" className="venue-btn">
                    LEARN MORE
                  </a> */}
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="venue-card">
                <img
                  src="https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773748805.png"
                  alt="Weddings"
                  className="venue-img"
                />

                <div className="venue-overlay">
                  <h3>Weddings</h3>

                  <p>
                    There’s something about hosting a wedding in a place that
                    already carries a sense of Indian culture and traditions; it
                    just feels different. The spaces here let the light, the
                    architecture, hospitality, and ambience do most of the work.
                    Whether it’s a larger celebration or something quieter with
                    close family, it tends to come together naturally.
                  </p>

                  {/* <a href="/codrington-room" className="venue-btn">
                    LEARN MORE
                  </a> */}
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="venue-card">
                <img
                  src="https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773748932.jpg"
                  alt="Special Occasion"
                  className="venue-img"
                />

                <div className="venue-overlay">
                  <h3>Special Occasion</h3>

                  <p>
                    Some celebrations don’t need a big reason; they just need
                    the right setting. Birthdays, anniversaries, small
                    gatherings that turn into long evenings, this is the kind of
                    place where those moments are cherished and enjoyed to the
                    fullest. Everything feels surreal and organised, and that’s
                    often what makes people remember it later.
                  </p>

                  {/* <a href="/codrington-room" className="venue-btn">
                    LEARN MORE
                  </a> */}
                </div>
              </div>
            </SwiperSlide>
            {/* <SwiperSlide>
              <div className="venue-card">
                <img
                  src="https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773651032.png"
                  alt="Codrington Room"
                  className="venue-img"
                />

                <div className="venue-overlay">
                  <h3>THE CODRINGTON ROOM</h3>

                  <p>
                    Enjoy the epitome of intimate elegance by selecting the
                    Codrington Room for your private wedding dinner.
                  </p>

                  <a href="/codrington-room" className="venue-btn">
                    LEARN MORE
                  </a>
                </div>
              </div>
            </SwiperSlide> */}
          </Swiper>
        </div>
      </section>

      <section className="services section-padding">
        <div className="container">
          <div className="row">
            <div
              className="col-md-6 p-0 order1 "
              data-animate-effect="fadeInRight"
            >
              <div className="img">
                <img
                  src="https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773747345.jpg"
                  alt=""
                />
              </div>
            </div>
            <div
              className="col-md-6 bg-blck p-0 order2 valign "
              data-animate-effect="fadeInLeft"
            >
              <div className="content">
                <div className="cont text-left">
                  <h2 className="section-title">
                    Perfect Menu for Every Celebration
                  </h2>
                  <p>
                    What your guests remember the most will always be the food.
                    At Chokhi Dhani London, every menu is created around the
                    rich culinary traditions of Rajasthan, bringing rich,
                    authentic flavours to the heart of your celebration. Our
                    experienced chefs prepare each dish with care and attention
                    that you simply cannot find in a standard banquet menu. From
                    hearty thali spreads to refined small plates, we let your
                    guests have the best gastronomical experience.
                  </p>
                  <div className="butn-dark">
                    {" "}
                    {/* <a href="/contact">
                      <span>ENQUIRE NOW NOW</span>
                    </a> */}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        const element = document.getElementById("weddingForm");
                        const offset = 80; // adjust header height
                        const position = element.offsetTop - offset;

                        window.scrollTo({
                          top: position,
                          behavior: "smooth",
                        });
                      }}
                    >
                      <span>ENQUIRE NOW</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="wedding-banner">
        <div className="banner-overlay">
          <div className="container text-center">
            <h2 className="banner-title">
              A Unique Indian Wedding Venue Experience in London
            </h2>

            <p className="banner-text">
              At Chokhi Dhani London, we have distinct spaces, each reflecting
              its own character. Your wedding can look and feel exactly the way
              you imagined it.
            </p>

            {/* <a href="javascript:void(0);" className="discover-btn">
              DISCOVER
            </a> */}

             <a
                      href="#"
                      className="discovers-btn new"
                      onClick={(e) => {
                        e.preventDefault();
                        const element = document.getElementById("weddingForm");
                        const offset = 80; // adjust header height
                        const position = element.offsetTop - offset;

                        window.scrollTo({
                          top: position,
                          behavior: "smooth",
                        });
                      }}
                    >
                      <span>ENQUIRE NOW</span>
                    </a>
          </div>
        </div>
      </section>

      <section
        className="rooms1 section-padding bg-blck-light"
        data-scroll-index="2"
      >
        <div className="container">
          <h2 className="text-center mb-4 section-title">
            Chokhi Dhani London Love Stories
          </h2>

          <div className="row">
            <div className="col-md-4">
              <div className="story-card">
                <img
                  src="https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773813128.jpeg"
                  className="story-img"
                  alt=""
                />

                <div className="story-overlay">
                  <h5>Cole & Caroline</h5>

                  <p>
                    When I started looking for wedding venues in London, I
                    honestly wasn't sure we’d find a place that felt close to
                    our motherland. When I visited Chokhi Dhani, I immediately
                    thought- this will be the wedding venue. The warmth, the
                    atmosphere, even the way everything was laid out, didn’t
                    feel like a typical wedding venue. The team was incredibly
                    supportive throughout, and by the wedding day, everything
                    came together so smoothly. It’s a day my wife and I will
                    always look back on with a smile.
                  </p>

                  {/* <a href="#" className="story-btn">
                    READ STORY
                  </a> */}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="story-card">
                <img
                  src="	https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773813093.jpeg"
                  className="story-img"
                  alt=""
                />

                <div className="story-overlay">
                  <h5>Arun & Chaula</h5>

                  <p>
                    Chokhi Dhani London was one of the first venues we visited,
                    and we didn’t feel the need to look further after that.
                    There was a certain ease about the place that we both liked
                    immediately. Planning an Indian wedding away from India can
                    feel overwhelming, but here, we didn't have to take any
                    stress. The food, the setting, the overall experience, it
                    all felt just so amazing. Our families and guests were
                    genuinely happy, which meant everything to us.
                  </p>

                  {/* <a href="#" className="story-btn">
                    READ STORY
                  </a> */}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="story-card">
                <img
                  src="https://www.chokhidhani.co.uk/csadmin/public/img/uploads/media/1773812976.jpeg"
                  className="story-img"
                  alt=""
                />

                <div className="story-overlay">
                  <h5>Eleanor & Julian</h5>

                  <p>
                    We chose Chokhi Dhani because we wanted a venue that could
                    reflect our Indian values and warm hospitality culture. From
                    our first visit to the final day, the entire experience was
                    smooth and surprisingly stress-free. The team paid attention
                    to the little things, which you don’t always notice until
                    later, but they make a big difference. Looking back, it
                    didn’t just feel like a well-organised wedding, it felt like
                    our kind of celebration.
                  </p>

                  {/* <a href="#" className="story-btn">
                    READ STORY
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {faqData && faqData.length > 0 && (
        <section className="faqs__ section-padding">
          <Container>
            <h2 className="text-center mb-4 section-title">
              Frequently Asked Questions
            </h2>

            <div
              className="accordion accordion-flush"
              id="accordionFlushExample"
            >
              {faqData.map((item, index) => {
                const collapseId = `flush-collapse-${index}`;
                const headingId = `flush-heading-${index}`;
                const isFirst = index === 0;

                return (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header" id={headingId}>
                      <button
                        className={`accordion-button ${isFirst ? "" : "collapsed"}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${collapseId}`}
                        aria-expanded={isFirst ? "true" : "false"}
                        aria-controls={collapseId}
                      >
                        {item?.faq_title}
                      </button>
                    </h2>

                    <div
                      id={collapseId}
                      className={`accordion-collapse collapse ${isFirst ? "show" : ""}`}
                      aria-labelledby={headingId}
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div
                        className="accordion-body"
                        dangerouslySetInnerHTML={{
                          __html: item?.faq_description,
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </Container>
        </section>
      )}

      <section id="weddingForm" className="contact wedding_form">
        <div className="container">
          <h2 className="text-center mb-4 section-title">
            Wedding Enquiry Form
          </h2>

          {/* Alerts */}
          {successMessage !== "" && (
            <div className="alert alert-success">{successMessage}</div>
          )}

          {errorMessage !== "" && (
            <div className="alert alert-danger">{errorMessage}</div>
          )}

          <form onSubmit={handleSubmit} className="contact__form">
            <div className="row">
              {/* ✅ ROW 1 */}
              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <input
                  type="text"
                  placeholder="Full Name *"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                />
              </div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <input
                  type="tel"
                  placeholder="Phone Number *"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <input
                  type="email"
                  placeholder="Email Address *"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              {/* ✅ ROW 2 */}
              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <input
                  type="date"
                  value={eventDate}
                  onChange={(e) => setEventDate(e.target.value)}
                  required
                />
              </div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <input
                  type="number"
                  placeholder="Number of Guests"
                  value={guests}
                  onChange={(e) => setGuests(e.target.value)}
                />
              </div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <select
                  value={contactTime}
                  onChange={(e) => setContactTime(e.target.value)}
                  required
                >
                  <option value="">Preferred Contact Time *</option>
                  <option value="Morning">Morning</option>
                  <option value="Afternoon">Afternoon</option>
                  <option value="Evening">Evening</option>
                  <option value="Anytime">Anytime</option>
                </select>
              </div>

              {/* ✅ ROW 3 */}
              <div className="col-12 mb-3">
                <textarea
                  rows="4"
                  placeholder="Additional Details / Message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>

              {/* ✅ CHECKBOX */}
              <div className="col-12 mb-3">
                <label className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    checked={agree}
                    onChange={(e) => setAgree(e.target.checked)}
                    className="me-2"
                  />
                  I agree to be contacted via phone, email, or WhatsApp
                  regarding my enquiry
                </label>
              </div>

              {/* ✅ BUTTON */}
              <div className="col-12 text-start">
                {/* <button type="submit" className="butn-dark2">
                  <span>Send Enquiry</span>
                </button> */}

                <button type="submit" className="butn-dark2" disabled={loading}>
                  <span>{loading ? "......." : "Send Enquiry"}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Weddings;
